import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

import Giris from './pages/Giris/Index'
import Kayit from './pages/Kayit/Index'
import Panel from './pages/Panel/Index'
import SayfaYok from './comp/SayfaYok'

// BİNA
import BinaIndex from './pages/Bina/Index'
import BinaListe from './pages/Bina/BinaListe'
import BinaDetay from './pages/Bina/BinaDetay'

// FATURA
import FaturaIndex from './pages/fatura/Index'
import FaturaListe from './pages/fatura/liste'

// BAKIM
import BakimIndex from './pages/bakim/Index'
import BakimListe from './pages/bakim/liste'

// CARİ
import CariIndex from './pages/cari/Index'
import CariListe from './pages/cari/liste'

// Ürün
import UrunIndex from './pages/urun/Index'
import UrunListe from './pages/urun/liste'

// Ekip
import EkipIndex from './pages/ekip/Index'
import EkipListe from './pages/ekip/liste'

// Personel
import PersonelIndex from './pages/personel/Index'
import PersonelListe from './pages/personel/liste'

// SMS
import SmsIndex from './pages/Sms/Index'

//QR
import Qr from './pages/qr'
import stok from './pages/stok'


//Bölge
import BolgeIndex from './pages/bolge/Index'
import BolgeListe from './pages/bolge/liste'


import AyarlarIndex from './pages/Ayarlar/Index'


Vue.use(VueRouter);

export const router = new VueRouter({
    routes: [
        {
            path: "/giris",
            component: Giris,
            beforeEnter(to, from, next) {
                if (store.getters.isOturum) {
                    next("/panel");
                } else {
                    next();

                }
            }
        },
        {
            path: "/kayit",
            component: Kayit,
            beforeEnter(to, from, next) {
                if (store.getters.isOturum) {
                    next("/panel");
                } else {
                    next();

                }
            }
        },
        {
            path: "/",
            component: Panel,
        },
        {
            path: "/panel",
            component: Panel,
        },
        {
            path: "/bina",
            component: BinaIndex,
            children: [
                {path: "", component: BinaListe},
                {
                    path: ":Bina_id", component: BinaDetay,
                },
            ],
        },
        {
            path: "/fatura",
            component: FaturaIndex,
            children: [
                {path: "", component: FaturaListe},

            ],
        },
        {
            path: "/bolge",
            component: BolgeIndex,
            children: [
                {path: "", component: BolgeListe},
            ],
        },
        {
            path: "/bakim",
            component: BakimIndex,
            children: [
                {path: "", component: BakimListe},
            ],
        },
        {
            path: "/cari",
            component: CariIndex,
            children: [
                {path: "", component: CariListe},
            ],
        },
        {
            path: "/urun",
            component: UrunIndex,
            children: [
                {path: "", component: UrunListe},
            ],
        },
        {
            path: "/personel",
            component: PersonelIndex,
            children: [
                {path: "", component: PersonelListe},
            ],
        },
        {
            path: "/ekip",
            component: EkipIndex,
            children: [
                {path: "", component: EkipListe},
            ],
        },
        {
            path: "/sms",
            component: SmsIndex,
        },
        {
            path: "/ayarlar",
            component: AyarlarIndex,
        },
        {
            path: "/qr",
            component: Qr,
        },
        {
            path: "/stok",
            component: stok,
        },
        {
            path: "*",
            component: SayfaYok,
        }

    ],
    mode: "history"
});



// WEBPACK FOOTER //
// ./src/router.js